import core from './core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  list(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  detail(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  activity(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail/activity',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  perform(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail/perform',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  profile(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/profile',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  memoList(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail/memoList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  memoSave(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail/saveMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  memoDelete(parameters={}) {
    return core.call({
      url: '/api/v1/orgStatus/detail/deleteMemo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  }
}
